module.exports = __webpack_public_path__ + "static/img/三维制作画面3.816bf1ce.png";